export default __webpack_public_path__ + "static/media/dac.3c153c12.gif";